import { createApi } from '@reduxjs/toolkit/query/react';

import {
  MoneyExpensesEndpoints as Endpoints,
  type AddMoneyExpenseRequest,
  type AddMoneyExpenseResponse,
  type DeleteMoneyExpenseRequest,
  type DeleteMoneyExpenseResponse,
  type GetFileRequest,
  type GetFileResponse,
} from '@app/api/MoneyExpenses/types';
import { createApiBaseQuery, Methods } from '@app/api/shared';
import { MONEY_EXPENSES } from '@app/constants';

export const moneyExpensesApi = createApi({
  reducerPath: 'moneyExpensesApi',
  baseQuery: createApiBaseQuery(MONEY_EXPENSES),
  endpoints: ({ mutation, query }) => ({
    [Endpoints.AddMoneyExpense]: mutation<
      AddMoneyExpenseResponse,
      AddMoneyExpenseRequest
    >({
      query: ({ data, ...params }) => ({
        url: Endpoints.AddMoneyExpense,
        method: Methods.POST,
        params,
        data,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }),
    }),
    [Endpoints.DeleteMoneyExpense]: mutation<
      DeleteMoneyExpenseResponse,
      DeleteMoneyExpenseRequest
    >({
      query: (params) => ({
        url: Endpoints.DeleteMoneyExpense,
        method: Methods.POST,
        params,
      }),
    }),
    [Endpoints.GetFile]: query<GetFileResponse, GetFileRequest>({
      query: ({ fileId, ...params }) => ({
        url: String(fileId),
        method: Methods.GET,
        params,
      }),
    }),
  }),
});

export const {
  useAddMoneyExpenseMutation,
  useDeleteMoneyExpenseMutation,
  useGetFileQuery,
  useLazyGetFileQuery,
} = moneyExpensesApi;
